import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Box, Button, Container, Paper, Stack, TextField, Typography } from "@mui/material";
import { redeemShareCode } from "../../axios/axiosFunctions";
import { ReportAccessContext } from "../../contexts/reportAccess";

const AccessReportCode = () => {
    const { setShare } = useContext(ReportAccessContext);
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (!email || !code) {
            setError("Enter your email and the 6-digit code from your email.");
            return;
        }
        setSubmitting(true);
        const res = await redeemShareCode(email.trim(), code.trim().toUpperCase());
        setSubmitting(false);
        if (res.error || !res.token) {
            setError(res.msg || "Invalid email or code.");
            return;
        }
        const { share } = res;
        setShare({
            token: res.token,
            shareId: share._id,
            groupId: share.group,
            assessmentId: share.assessment,
            recipientEmail: share.recipientEmail,
            recipientName: share.recipientName,
            viewerUserId: res.viewerUserId,
        });
        // Route to the report of the shared assessment (TIM or an as-is clone such
        // as Executive Team Assessment). Fall back to TIM for old shares.
        const reportSlug = share.assessmentSlug || "tim_self_assessment";
        navigate(`/${reportSlug}/${share.group}/report`, { replace: true });
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 8 }}>
            <Paper sx={{ p: 4 }}>
                <Typography variant="h5" color="secondary" fontWeight={600} sx={{ mb: 1 }}>
                    Access your shared report
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Enter the email address the report was sent to and the 6-digit access code
                    from the email.
                </Typography>
                <Box component="form" onSubmit={handleSubmit}>
                    <Stack spacing={2}>
                        <TextField
                            label="Email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email"
                            fullWidth
                            required
                        />
                        <TextField
                            label="6-digit code"
                            value={code}
                            onChange={(e) => setCode(e.target.value.toUpperCase())}
                            inputProps={{ maxLength: 6, style: { letterSpacing: 4, fontFamily: "monospace" } }}
                            fullWidth
                            required
                        />
                        {error && <Alert severity="error">{error}</Alert>}
                        <Button
                            type="submit"
                            variant="contained"
                            color="secondary"
                            disabled={submitting}
                            size="large"
                        >
                            {submitting ? "Verifying…" : "View report"}
                        </Button>
                    </Stack>
                </Box>
            </Paper>
        </Container>
    );
};

export default AccessReportCode;
